<template>
  <div class="tab-pane active" id="form-step-1">
    <message-box :type="1" />
    <div v-if="loadError" class="alert alert-danger" role="alert">
      <strong>Unable to load registration form data:</strong> {{ loadError }}
      <br />
      <small>Please try refreshing the page or contact support if the problem persists.</small>
    </div>
    <div class="row">
      <!-- <div class="col-sm-12">
        <h4 class="info-text ">
         Our webinars and virtual events are open to all and access is complimentary thanks to the generous support of Smart Currency Exchange.
        </h4>
        <div class="alert alert-info" role="alert">
          During the webinar registration you can register your initial interest with Smart Currency Exchange - a payment specialist dedicated to supporting international property buyers.
          </div>
        
      </div> -->
      <div class="col-sm-12" v-if="countriesOfInterest.length">
        <div class="form-group">
          <label class="form-label required">Country of interest</label>
          <select
            name="countries"
            class="form-control custom-select"
            required
            v-model="countryBuyingIn"
            :class="{ error: errors.has('step1.countries') }"
            data-vv-scope="step1"
            v-validate="'required'"
            @change="onChangeCountry"
          >
            <option value="" selected="selected"
              >Please select a country...</option
            >

            <option
              v-for="country in countriesOfInterest"
              :key="country.CountryId"
              :value="country"
              >{{ country.CountryName }}</option
            >
          </select>
        </div>
      </div>
      <div class="col-sm-12" v-if="countryBuyingIn">
        <div class="form-group" v-if="filteredWebinars">
          <label class="form-label required">Webinars/Events</label>
          <Webinar
            v-for="webinar in filteredWebinars"
            :key="webinar.id"
            :webinarInfo="webinar"
          ></Webinar>
          <!-- <select
            name="webinar"
            class="form-control custom-select"
            required
            v-model="webinar"
            :class="{ error: errors.has('step1.webinar') }"
            data-vv-scope="step1"
            v-validate="'required'"
          >
            <option value="" selected="selected"
              >Please select a webinar/event...</option>

              <option v-for="webinar in filteredWebinars" :key="webinar.id" :value="webinar"
              >{{webinar.name}}</option>
          </select> -->
        </div>
        <div v-else>
          <p>
            There are no webinars currently available. Check our
            <a href="https://www.youroverseashome.com/on-demand/">on demand</a>
            page for more details.
          </p>
        </div>
      </div>
      <div class="col-sm-12 mt-2">
        <privacy-policy />
      </div>
      <Loading v-if="loading" />
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import Loading from "@/components/ui/Loading.vue";
import Webinar from "@/components/ui/Webinar.vue";
import axios from "axios";
import mixin from "@/components/shared/mixinUtility";
import { Common } from "@/helper/common";
import MessageBox from "@/components/ui/MessageBox.vue";
import PrivacyPolicy from "@/components/ui/PrivacyPolicy.vue";
import { trackWebinarSelectionError } from "@/helper/datadog";
export default {
  name: "WebinarSelection",
  mixins: [mixin],
  computed: {
    ...mapFields(["form.countryBuyingIn", "campaignCountryCodeMapping"]),
    ...mapGetters({
      countries: "getCountries",
      webinars: "getWebinars",
      registerables: "getRegisterables",
      countriesOfInterest: "getCountriesOfInterest",
    }),
    filteredWebinars() {
      return this.countryBuyingIn &&
        this.countryBuyingIn.CountryId &&
        this.registerables.length
        ? this.registerables
        : null;
    },
  },
  watch: {
    countryBuyingIn() {
      this.fetchRegisterables();
    },
  },
  components: {
    Loading,
    Webinar,
    "message-box": MessageBox,
    "privacy-policy": PrivacyPolicy,
  },
  data() {
    return {
      error: null,
      loading: false,
      loadError: null,
    };
  },
  methods: {
    async fetchRegisterables() {
      if (!this.countryBuyingIn || !this.countryBuyingIn.CRMCountryId) {
        this.$store.dispatch("setRegisterables", []);
        return;
      }
      try {
        const { data } = await axios.get(
          process.env.VUE_APP_API_URL +
            `/client/GetRegisterables?crmCountryId=${this.countryBuyingIn.CRMCountryId}`
        );
        let registerables = (data.objectCollection || []).map((r) => {
          // countries isn't on the registerable (it's scoped to one country by design);
          // pull it from the country-agnostic GetYohEvents list instead, still used by Preference.vue.
          const yohEvent = this.webinars.find((w) => w.id === r.webinarId);
          return {
            id: r.webinarId,
            name: r.name,
            endDate: r.startTime,
            sourceSite: r.sourceSite,
            virtualEvent: r.isVirtualEvent,
            countries: yohEvent ? yohEvent.countries : [],
          };
        });

        const virtualParam = Common.getQuerystring("virtual").trim().toLowerCase();
        if (virtualParam === "yes") {
          registerables = registerables.filter((r) => r.virtualEvent);
        }

        this.$store.dispatch("setRegisterables", registerables);
      } catch (err) {
        console.warn("Registerable fetch error (non-critical):", err);
        const errorMsg = err.response?.statusText || err.message || "Unknown error";
        trackWebinarSelectionError(
          "FetchRegisterables_failed",
          errorMsg,
          {
            status: err.response?.status,
            url: err.config?.url,
            crmCountryId: this.countryBuyingIn?.CRMCountryId,
          }
        );
        this.$store.dispatch("setRegisterables", []);
      }
    },
    async getEvents() {
      try {
        const res = await axios.get(
          process.env.VUE_APP_API_URL + "/client/GetYohEvents"
        );

        if (res.data.objectCollection && res.data.objectCollection.length) {
          let events = res.data.objectCollection;

          // Retrieve query parameters
          const virtualParam = Common.getQuerystring("virtual")
            .trim()
            .toLowerCase();
          const chaseBuchananParam = Common.getQuerystring("chasebuchanan")
            .trim()
            .toLowerCase();
          const holbornParam = Common.getQuerystring("holborn")
            .trim()
            .toLowerCase();

          // Apply filters based on parameters
          if (virtualParam === "yes") {
            events = events.filter((e) => e.virtualEvent);
          } else if (chaseBuchananParam === "yes") {
            events = events.filter(
              (e) => e.jvpId === 1183055 || e.jvpId === 1183054
            );
          } else if (holbornParam === "yes") {
            events = events.filter((e) => e.jvpId === 1352663);
          }

          // Extract virtual events for store dispatch
          const virtualEvent = events.find((e) => e.virtualEvent);
          if (virtualEvent) {
            this.$store.dispatch("setVirtualEvent", virtualEvent);
          }

          // Store filtered events
          this.$store.dispatch("setWebinars", events);
        }
      } catch (err) {
        const errorMsg = err.response?.statusText || err.message || "Unknown error";
        trackWebinarSelectionError(
          "GetYohEvents_failed",
          errorMsg,
          {
            status: err.response?.status,
            url: err.config?.url,
          }
        );
        throw new Error(`Failed to load webinars: ${errorMsg}`);
      }
    },
    async fetchCountries() {
      try {
        const res = await axios.get(
          process.env.VUE_APP_REGIONS_API_URL + "/api/v1/Countries"
        );
        const countries = res.data.data
          .filter((c) => c.showOnSite && c.regionCountryId !== null)
          .map((c) => ({
            CountryId: c.regionCountryId,
            CRMCountryId: c.crmCountryId,
            CountryName: c.name,
            TwoCharCode: c.twoCharCode,
          }));
        this.$store.dispatch("setCountries", countries);
      } catch (err) {
        const errorMsg = err.response?.statusText || err.message || "Unknown error";
        trackWebinarSelectionError(
          "FetchCountries_failed",
          errorMsg,
          {
            status: err.response?.status,
            url: err.config?.url,
          }
        );
        throw new Error(`Failed to load countries: ${errorMsg}`);
      }
    },
    drawWebinars() {
      const webinars = this.webinars;
      let uniqueCountryIds = [];
      webinars.forEach((w) => {
        w.countries.forEach((countryId) => {
          if (!uniqueCountryIds.includes(countryId))
            uniqueCountryIds.push(countryId);
        });
      });

      const countriesOfInterest = this.countries.filter((el1) =>
        uniqueCountryIds.map((el2) => el2).includes(el1.CountryId)
      );

      this.$store.dispatch(
        "setCountriesOfInterest",
        countriesOfInterest.sort((a, b) => (a.CountryName > b.CountryName ? 1 : -1))
      );
    },
    onChangeCountry() {
      this.$store.dispatch("setWebinar", "");
    },
    setCountryFromQueryString() {
      // Extract the utm campaign string
      const campaign = this.$route.query.utm_campaign;
      if (!campaign) return;

      // The campaign country code should be the second value in the string
      const campaignCountryCode = campaign.split("_")[1];
      if (!campaignCountryCode) return;

      // Use the mapping to get the country code like "ES"
      const countryCode = this.campaignCountryCodeMapping[
        campaignCountryCode.toUpperCase()
      ];
      if (!countryCode) return;

      // Set country selection to country passed in url parameters if it's an option in countriesOfInterest
      const targetCountry = this.countriesOfInterest.find(
        (x) => x.TwoCharCode.toLowerCase() === countryCode.toLowerCase()
      );
      if (targetCountry) this.countryBuyingIn = targetCountry;
    },
  },
  async created() {
    try {
      this.resetMessageInfo();
      this.loading = true;
      this.loadError = null;

      try {
        if (!this.countries.length) await this.fetchCountries();
      } catch (err) {
        this.loadError = "Unable to load country list. Please try refreshing the page.";
        this.loading = false;
        return;
      }

      try {
        if (!this.webinars.length) await this.getEvents();
      } catch (err) {
        this.loadError = err.message;
        this.loading = false;
        return;
      }

      if (this.webinars.length > 0) {
        if (!this.countriesOfInterest.length) this.drawWebinars();
      } else {
        this.showGenericErrorMessage("There are no events available.", false);
      }

      if (this.countryBuyingIn && !this.registerables.length) {
        try {
          await this.fetchRegisterables();
        } catch (err) {
          console.log("Registerable fetch error (non-critical):", err);
        }
      }

      this.loading = false;
    } catch (err) {
      this.loadError = "An unexpected error occurred. Please try refreshing the page.";
      trackWebinarSelectionError(
        "WebinarSelection_created_unexpected",
        err.message,
        { stack: err.stack }
      );
      this.loading = false;
    }

    this.setCountryFromQueryString();
  },
};
</script>
